<template>
  <v-container>
    <the-header :title="getLabel('new_group')" :go-back="goBack" />
    <v-card elevation="5" class="rounded-lg">
      <v-sheet elevation="3" class="rounded-lg rounded-b-0" color="primary">
        <v-card-title class="text-h6 white--text">{{ getLabel("create_group") }}</v-card-title>
      </v-sheet>
      <v-divider />
      <v-card-text>
        <v-alert v-if="errors.length" type="error" class="rounded-lg" dismissible @input="closeAlert">
          <div v-for="(error, index) in errors" :key="index">{{ error }}</div>
        </v-alert>
        <v-alert v-if="successes.length" type="success" class="rounded-lg" dismissible @input="closeAlert">
          <div v-for="(success, index) in successes" :key="index">{{ success }}</div>
        </v-alert>
        <v-form ref="groupForm">
          <v-text-field
            v-model="newGroup.name"
            v-bind="groupFieldsProperties('name')"
          />
          <v-textarea
            v-model="newGroup.description"
            v-bind="groupFieldsProperties('description')"
          />
          <v-form />
        </v-form>
      </v-card-text>
      <v-divider />
      <v-card-text class="d-flex justify-end">
        <v-btn x-large color="warning" @click="resetForm()">
          <v-icon class="mr-3">mdi-broom</v-icon>
          {{ getLabel("clean") }}
        </v-btn>
        <v-btn x-large class="ml-4" color="success" @click="createGroup()">
          <v-icon class="mr-3">mdi-content-save</v-icon>
          {{ getLabel("save") }}
        </v-btn>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { ref } from '@vue/composition-api';
import { useRouter } from 'vue2-helpers/vue-router';
import { useMutation } from '@vue/apollo-composable';

import { useMainStore } from '../../store/index';
import { groupFieldsProperties } from '@/utils/forms';
import { getLabel } from '@/utils/index';
import { getGraphqlSchema } from '../../graphql/index';

import TheHeader from '../UI/TheHeader.vue';

export default {
  components: { TheHeader },
  setup (props, context) {
    const router = useRouter();

    const store = useMainStore();

    const errors = ref([]);

    const successes = ref([]);

    const closeAlert = () => {
      errors.value = [];
      successes.value = [];
    };

    const goBack = () => {
      router.back();
    };

    const newGroup = ref({
      name: null,
      description: null
    });

    const resetForm = () => {
      context.refs.form.reset();
      errors.value = [];
      successes.value = [];
    };

    // Create Group
    const { mutate: mutationCreateGroup, error: sendMessageError, onDone, onError } = useMutation(getGraphqlSchema('createGroup'), () => ({
      variables: {
        name: newGroup.value.name,
        description: newGroup.value.description
      }
    }));

    onError(() => {
      store.loading = false;

      // when the createGroup mutation returns an error
      successes.value = [];
      errors.value = [sendMessageError.value.message];
    });

    onDone(() => {
      store.loading = false;

      context.refs.groupForm.reset();

      errors.value = [];
      successes.value = [getLabel('group_saved')];
    });

    const createGroup = () => {
      if (context.refs.groupForm.validate()) {
        store.loading = true;
        mutationCreateGroup();
      } else {
        successes.value = [];
        errors.value = [getLabel('check_fields')];
      }
    };

    return { getLabel, groupFieldsProperties, errors, successes, goBack, closeAlert, newGroup, resetForm, createGroup };
  }
};

</script>
